const DECIMAL_PLACES = 2;

export function round(value: number, decimalPlaces: number = DECIMAL_PLACES) {
	const factor = Math.pow(10, decimalPlaces);
	return (value >= 0 ? 1 : -1) * Math.round(Math.abs(value) * factor) / factor;
}

export function mult(values: number[], decimalPlaces: number = DECIMAL_PLACES) {
	let result = 1;
	for (let i = 0; i < values.length; i++)
		result *= values[i];
	return round(result, decimalPlaces);
}

export function div(d1: number, d2: number, decimalPlaces: number = DECIMAL_PLACES) {
	return round(d1 / d2, decimalPlaces);
}

export function margin(cost: number, price: number, decimalPlaces: number = DECIMAL_PLACES) {

	if (cost === 0 && price === 0)
		return 0;

	// Esto es más que discutible porque realmente es -infinito, pero ponte tú a explicarle al
	// tendero teoría de números
	if (price === 0)
		return -100;

	return round(100 * (1 - cost / price), decimalPlaces);
}